import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";


const ContactSection = () => {


     useEffect(() => {
    AOS.init();
  }, []);


  return (
    <section className="bg-bgDefault text-white px-10 py-28 lg:px-16 lg:py-28">
      <div className="container xl:mx-auto xl:max-w-screen-xl overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-12  lg:gap-10 gap-20 items-start" data-aos="fade-up">
          
          {/* Left Content */}
          <div className=" lg:col-span-7">
            <div className="text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em]  mb-4 lg:pr-44 ">
              Have an idea
              project, or just want 
              to say hello?
            </div>
            <p className="text-[#9E9E9E] text-body-sm md:text-body font-roboto  lg:mr-16">
              We’d love to hear from you! Whether you're ready to launch your next big product, 
              need a tech partner for your startup, or simply want to explore how future-ready 
              technology can transform your business — we’re here to help.
            </p>
          </div>

          {/* Right Form Card */}
          <div className=" lg:col-span-5">
            <div className="bg-[#242424B2] border border-[#2e2e2e]  lg:px-10 lg:py-10 px-4 py-4md:p-8 text-center">
              <h3 className="lg:text-heading-4 text-heading-5 text-white font-semibold mb-2">Not sure where to start?</h3>
              <p className="text-[#9E9E9E] lg:text-base text-body-sm font-roboto mb-6">
                That’s okay. Just tell us a bit about your goals – we’ll guide you through the next steps.
              </p>

              <form className="space-y-4">
                <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
                  <input
                    type="text"
                    placeholder="Name"
                    className="bg-transparent border border-[#494949] text-white text-sm lg:px-3 lg:py-4  px-2 py-3 focus:outline-none focus:ring-1 focus:ring-[#4caf8e]"
                  />
                  <input
                    type="text"
                    placeholder="Phone"
                    className=" bg-transparent border border-[#494949] text-white text-sm lg:px-3 lg:py-4   px-2 py-3  focus:outline-none focus:ring-1 focus:ring-[#4caf8e]"
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    className="  bg-transparent border border-[#494949] text-white text-sm lg:px-3 lg:py-4   px-2 py-3 focus:outline-none focus:ring-1 focus:ring-[#4caf8e]"
                  />
                  <input
                    type="text"
                    placeholder="Service"
                    className=" bg-transparent border border-[#494949] text-white text-sm lg:px-3 lg:py-4    px-2 py-3 focus:outline-none focus:ring-1 focus:ring-[#4caf8e]"
                  />
                </div>

                <textarea
                  placeholder="Message"
                  rows="4"
                  className="bg-transparent border border-[#494949] text-white text-sm px-3 py-2 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-[#4caf8e]"
                />

               <button
                type="submit"
                className="w-full bg-[#00E599] text-black font-dmsans font-extrabold text-body lg:text-[20px] lg:leading-[100%] text-center lg:py-4 lg:px-14 px-2 py-2 hover:bg-[#00e6a1] transition"
              >
                Book a Free Discovery Call
              </button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;
